import {defineStore} from 'pinia'
import {computed, ref} from 'vue'

export const useSimulationStore = defineStore('simulation', () => {


    const TYPE_RENT = 'type_rent';
    const TYPE_LIVING = 'type_living';
    const TYPE_LIVING_UTILITY = 'type_living_utility';
    const TYPE_LIVING_TEL = 'type_living_tel';
    const TYPE_LIVING_FOOD = 'type_living_food';
    const TYPE_LIVING_DAILY = 'type_living_daily';
    const TYPE_LIVING_TRANS = 'type_living_trans';
    const TYPE_LIVING_ENTERTAINMENT = 'type_living_entertainment';
    const TYPE_LIVING_OTHER = 'type_living_other';
    const TYPE_OTHER = 'type_other';

    const prefecture_name: any = ref(0);
    const take_home_pay: any = ref(0);

    const rent: any = ref(0);
    const max_rent: any = ref(0);
    const average_rent: any = ref(0);
    const average_rent_par: any = ref(0);

    const living: any = ref(0);
    const max_living: any = ref(0);
    const average_living: any = ref(0);
    const average_living_par: any = ref(0);

    const living_utility: any = ref(0);
    const max_living_utility: any = ref(0);
    const living_tel: any = ref(0);
    const max_living_tel: any = ref(0);
    const living_food: any = ref(0);
    const max_living_food: any = ref(0);
    const living_daily: any = ref(0);
    const max_living_daily: any = ref(0);
    const living_trans: any = ref(0);
    const max_living_trans: any = ref(0);
    const living_entertainment: any = ref(0);
    const max_living_entertainment: any = ref(0);
    const living_other: any = ref(0);
    const max_living_other: any = ref(0);

    const other: any = ref(0);
    const max_other: any = ref(0);
    const average_other: any = ref(0);
    const average_other_par: any = ref(0);


    const max = computed(() => {
        return max_rent.value + max_living.value + max_other.value
    })

    const total = computed(() => {
        return parseInt(rent.value) + parseInt(living.value) + parseInt(other.value)
    })

    const par = computed(() => {
        return Math.floor(total.value / max.value * 100);
    })

    const free_money = computed(() => {
        return take_home_pay.value - total.value;
    })

    const update = (type) => {
        if ([TYPE_RENT, TYPE_LIVING, TYPE_OTHER].includes(type)) {
            return;
        }
        living.value = parseInt(living_utility.value) + parseInt(living_tel.value) + parseInt(living_food.value) + parseInt(living_daily.value) + parseInt(living_trans.value) + parseInt(living_entertainment.value) + parseInt(living_other.value);
    }

    const init = (company) => {

        prefecture_name.value = company.prefecture_name;
        take_home_pay.value = company.take_home_pay;
        rent.value = company.rent;
        max_rent.value = company.max_rent;
        average_rent.value = company.average_rent;
        average_rent_par.value = (company.average_rent / company.max_rent) * 100;

        living.value = company.living;
        max_living.value = company.max_living;
        average_living.value = company.average_living;
        average_living_par.value = (company.average_living / company.max_living) * 100;

        living_utility.value = company.living_utility;
        max_living_utility.value = company.max_living_utility;
        living_tel.value = company.living_tel;
        max_living_tel.value = company.max_living_tel;
        living_food.value = company.living_food;
        max_living_food.value = company.max_living_food;
        living_daily.value = company.living_daily;
        max_living_daily.value = company.max_living_daily;
        living_trans.value = company.living_trans;
        max_living_trans.value = company.max_living_trans;
        living_entertainment.value = company.living_entertainment;
        max_living_entertainment.value = company.max_living_entertainment;
        living_other.value = company.living_other;
        max_living_other.value = company.max_living_other;

        other.value = company.other;
        max_other.value = company.max_other;
        average_other.value = company.average_other;
        average_other_par.value = (company.average_other / company.max_other) * 100;

    }

    const getData = (type) => {
        switch (type) {
            case TYPE_RENT:
                return {
                    max: max_rent,
                    value: rent,
                    avg: average_rent,
                    avg_par: average_rent_par,
                    label: "月々の家賃",
                    avg_label: prefecture_name.value + "平均",
                };
            case TYPE_OTHER:
                return {max: max_other, value: other, label: "その他の支出（奨学金・ローンなど）"};
            case TYPE_LIVING:
                return {
                    max: max_living,
                    value: living,
                    avg: average_living,
                    avg_par: average_living_par,
                    label: "月々の生活費",
                    avg_label: "全国平均"
                };
            case TYPE_LIVING_UTILITY:
                return {max: max_living_utility, value: living_utility, label: "光熱費"};
            case TYPE_LIVING_TEL:
                return {max: max_living_tel, value: living_tel, label: "通信費"};
            case TYPE_LIVING_FOOD:
                return {max: max_living_food, value: living_food, label: "食費"};
            case TYPE_LIVING_DAILY:
                return {max: max_living_daily, value: living_daily, label: "日用品費"};
            case TYPE_LIVING_TRANS:
                return {max: max_living_trans, value: living_trans, label: "交通費"};
            case TYPE_LIVING_ENTERTAINMENT:
                return {max: max_living_entertainment, value: living_entertainment, label: "娯楽・交際費"};
            case TYPE_LIVING_OTHER:
                return {max: max_living_other, value: living_other, label: "雑費"};
            default:
                return null;
                break;
        }
    }

    const getLivingChildTypes = () => {
        return [
            TYPE_LIVING_UTILITY,
            TYPE_LIVING_TEL,
            TYPE_LIVING_FOOD,
            TYPE_LIVING_DAILY,
            TYPE_LIVING_TRANS,
            TYPE_LIVING_ENTERTAINMENT,
            TYPE_LIVING_OTHER
        ];
    }

    return {
        init,
        getData,
        getLivingChildTypes,
        update,
        max,
        total,
        par,
        free_money,

        TYPE_RENT,
        TYPE_LIVING,
        TYPE_OTHER,
        rent,
        max_rent,
        average_rent,
        average_rent_par,

        living,
        max_living,
        average_living,
        average_living_par,

        living_utility,
        max_living_utility,
        living_tel,
        max_living_tel,
        living_food,
        max_living_food,
        living_daily,
        max_living_daily,
        living_trans,
        max_living_trans,
        living_entertainment,
        max_living_entertainment,
        living_other,
        max_living_other,

        other,
        max_other,
        average_other,
        average_other_par
    }
})